<template>
  <div class="user-settings">
    <div class="settings-container">
      <!-- 页面标题 -->
      <div class="page-header">
        <h1 class="page-title">{{ $t('_szzx._sz') }}</h1>
      </div>

      <!-- 设置选项列表 -->
      <div class="settings-list">
        <!-- 修改头像 -->
        <div class="setting-item" @click="onShowEdit">
          <div class="setting-info sszte">
            <div class="sz-avatar">
              <img :src="user.avatar && user.avatar + '?r_avatar=' + parseInt(Math.random() * 1000)" />
            </div>
            <div class="sdfkjtt">
              <div class="sttqr">{{ user.email }}</div>
              <div class="stgst">{{ user.uid }}</div>
            </div>
            <!-- <h3>{{ $t('_sz._smrz') }}</h3> -->
            <!-- <p :class="isAuth.class" v-if="user.is_auth">{{ isAuth.text }}</p> -->
          </div>
          <div class="setting-right">
            <span class="stgtqe1">{{ $t('_sz._bjtx') }}</span>
            <span class="arrow"> ›</span>
          </div>
        </div>

        <!-- 实名认证 -->
        <div class="setting-item" @click="onShowAuth">
          <div class="setting-info">
            <h3>{{ $t('_sz._smrz') }}</h3>
            <p :class="isAuth.class" v-if="user.is_auth">{{ isAuth.text }}</p>
          </div>
          <div class="setting-right">
            <span class="arrow">›</span>
          </div>
        </div>

        <!-- 修改密码 -->
        <div class="setting-item" @click="onShowPasswd">
          <div class="setting-info">
            <h3>{{ $t('_mm._xgmm') }}</h3>
            <p>{{ $t('_mm._dqxg') }}</p>
          </div>
          <div class="setting-right">
            <span class="arrow">›</span>
          </div>
        </div>

        <!-- 交易密码 -->
        <div class="setting-item" @click="onShowTradePasswd">
          <div class="setting-info">
            <h3>{{ $t('_szzx._jymm') }}</h3>
            <p>{{ $t('_szzx._szjymm') }}</p>
          </div>
          <div class="setting-right">
            <span class="arrow">›</span>
          </div>
        </div>
      </div>

      <!-- 退出登录按钮 -->
      <div class="logout-section">
        <button class="logout-btn" @click="handleLogout">{{ $t('_szzx._tcdl') }}</button>
      </div>
    </div>

    <!-- 编辑头像 -->
    <EditUser ref="edit" @success="onEditSuccess"></EditUser>
    <!-- 认证弹框 -->
    <AuthBox ref="auth"></AuthBox>

    <!-- 修改密码弹窗 -->
    <PasswdBox ref="passwd"></PasswdBox>

    <!-- 交易密码弹窗 -->
    <TradePasswdBox ref="tradePasswd"></TradePasswdBox>
  </div>
</template>

<script>
import EditUser from '@/components/setting/EditUser.vue'
import AuthBox from '@/components/setting/AuthBox.vue'
import PasswdBox from '@/components/setting/PasswdBox.vue'
import TradePasswdBox from '@/components/setting/TradePasswdBox.vue'
export default {
  name: 'UserSettings',
  components: { EditUser, AuthBox, PasswdBox, TradePasswdBox },
  data() {
    return {
      user: {}
    }
  },
  computed: {
    isAuth() {
      return this.user.is_auth == 2 ? { text: this.$t('_szzx._yrz'), class: 'status-verified' } : { text: this.$t('_szzx._wrz'), class: 'status-unverified' }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let that = this
      this.$api.user.getUserInfo().then((res) => {
        that.user = res.data
        localStorage.setItem(this.$Const.KEY_INFO, JSON.stringify(res.data))
      })
    },
    onShowEdit() {
      this.$refs.edit.show()
    },
    onEditSuccess() {
      this.init()
    },
    onShowAuth() {
      this.$refs.auth.show()
    },
    onShowPasswd() {
      this.$refs.passwd.show()
    },
    onShowTradePasswd() {
      this.$refs.tradePasswd.show()
    },
    handleLogout() {
      let that = this
      this.$confirm({
        title: this.$t('_szzx._tcdl'),
        content: this.$t('_szzx._qdtcdl'),
        okText: this.$t('_szzx._qrtc'),
        cancelText: this.$t('_szzx._qx'),
        onOk() {
          setTimeout(function () {
            localStorage.removeItem(that.$Const.KEY_TOKEN)
            localStorage.removeItem(that.$Const.KEY_INFO)
            that.$router.push({ name: 'index' })
          }, 500)
        }
      })
    }
  }
}
</script>

<style scoped>
@import url('../../static/css_setting/1.css');
</style>
<style scoped>
.sz-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  overflow: hidden;
}
.sz-avatar img {
  width: 100%;
  height: 100%;
}

.sszte {
  display: flex;
  align-items: center;
  gap: 10px;
}
.sttqr {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}

.sdfkjtt {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.stgst {
  color: #888;
}

.stgtqe1 {
  color: #888;
  font-size: 14px;
}
</style>
